import $ from 'jquery';
export default class ProfileButton {
  constructor(el) {
    this.el = el;

    var publicViewHost = 'cpe.newschool.edu'; // e.g., pv.destinysolutons.com

    fetch('https://' + publicViewHost, { mode: 'no-cors' })
      .then(() => {
        $.ajax({
          type: 'GET',
          url: 'https://' + publicViewHost + '/restricted/common/sessionInfo.jsp',
          async: true,
          dataType: 'jsonp',
        }).done(function (json) {
          var isStudentLogon = json['isStudentLogon'];
          if (isStudentLogon == 'yes') {
            console.log('logged in');
          } else {
            $(el).attr(
              'href',
              'https://' +
                publicViewHost +
                json['studentLogonUrl'] +
                '&parentSite=exec'
            );
          }
        });
      })
      .catch(() => {
        console.log('destiny not reachable');
      });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ProfileButton.js